import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Switch } from '@/components/ui/switch';
import { Label } from '@/components/ui/label';
import { BarChart2 } from 'lucide-react';
import { useState } from 'react';

export const PollSettings = () => {
  const [enabled, setEnabled] = useState(true);

  return (
    <Card>
      <CardHeader>
        <div className="flex items-center gap-2">
          <BarChart2 className="w-5 h-5 text-primary" />
          <CardTitle>Poll</CardTitle>
        </div>
        <CardDescription>
          Administrer avstemninger og meningspoll
        </CardDescription>
      </CardHeader>
      <CardContent className="space-y-6">
        <div className="flex items-center justify-between">
          <Label htmlFor="poll-enabled">Aktivert</Label>
          <Switch
            id="poll-enabled"
            checked={enabled}
            onCheckedChange={setEnabled}
          />
        </div>

        <div className="space-y-2">
          <Label>Generering</Label>
          <p className="text-sm text-muted-foreground">
            Konfigurer hvordan AI genererer relevante avstemninger fra artikkelinnhold.
          </p>
        </div>

        <div className="pt-4 border-t">
          <Button>Lagre innstillinger</Button>
        </div>
      </CardContent>
    </Card>
  );
};
